// We use document ready here instead of turbo:load because we want to use .on('click') and have it work
// for all components on the page, even if they are loaded after the initial page load.
$(document).ready(function() {

  // Be careful to only interact with the component that was clicked. Keep in mind that
  // there could be multiple components of the same type on the page!

  // Show the hidden text and hide the main text when the main text is clicked.
  $(document).on('click', '.examples-getting-started-component .main-text', function () {
    // Get the closest parent component.
    const parent = $(this).closest('.examples-getting-started-component');
    $(this).hide(); // Hide the main text.
    parent.find('.hidden-text').show(); // Show the hidden text inside the same component.
  });

  // This is the reverse of the above. It shows the main text and hides the hidden text.
  $(document).on('click', '.examples-getting-started-component .hidden-text', function () {
    // Get the closest parent component.
    const parent = $(this).closest('.examples-getting-started-component');
    $(this).hide(); // Hide the hidden text.
    parent.find('.main-text').show(); // Show the main text inside the same component.
  });

});
